mutation UpdatePlatformStreamingSettings(
  $platformId: ID!
  $input: UpdateStreamingSettingsInput!
) {
  updatePlatformStreamingSettings(platformId: $platformId, input: $input) {
    id
    streamingSettings {
      accountId
      apiTokenMask
      connectedAt
    }
  }
}
